package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.abc_statistic.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.model.general.FooterType
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.abc_statics.ABCStatisticTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.abc_statics.abc_statistic_data.ABCStatisticItem
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.extractTime
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.LineStyle


@Composable
fun ABCStatisticTable(
    items: List<ABCStatisticItem>?,
) {

    Column(
        modifier = Modifier
            .fillMaxHeight()
            .borderSetting()
            .borderRadius(Dimen.semiLargeRadius)
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
    )
    {
        MediumContentTitle(
            title = Strings.current().abcStatistic,
            marginBottom = Dimen.largePadding,
        )

        ABCFilters()

        key(items) {
            val (columns, tableData, footerData) = setABCStatisticTableInfo(items)

            CustomTable(
                columns = columns,
                data = tableData,
                minHeight = Dimen.abcTableMinHeight,
                showRefreshButton = false,
                footerType = FooterType.ALIGNED,
                footerData = footerData
            )
        }

    }

}

@Composable
private fun ABCFilters()
{
    Row(
        modifier = Modifier
            .margin(bottom = Dimen.normalPadding,)
    )
    {
        CustomIcon(
            modifier = Modifier
                .margin(right = Dimen.normalPadding),
            iconColor = Theme.PrimaryMain.hex,
            icon = Res.PathIcon.export ,
            onIconClick = {

            }
        )

        CustomIcon(
            modifier = Modifier
                .margin(right = Dimen.normalPadding),
            iconColor = Theme.PrimaryMain.hex,
            icon = Res.PathIcon.pdf ,
            onIconClick = {

            }
        )

        CustomIcon(
            modifier = Modifier
                .margin(right = Dimen.extraLargePadding),
            iconColor = Theme.PrimaryMain.hex,
            icon = Res.PathIcon.filter,
            onIconClick = {

            }
        )

        DraggedFilter()


    }



}

@Composable
private fun DraggedFilter()
{
    Row(
        modifier = Modifier
            .width(Dimen.draggedFilterInputWidth)
            .height(Dimen.filterHeight)
            .borderRadius(Dimen.draggedFilterBorderRadius)
            .backgroundColor(Theme.ActionHover.rgb)
            .border(
                width = Dimen.smallThickness,
                color = Theme.ActionDisabledBackground.rgb,
                style = LineStyle.Dotted
            ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center,
    )
    {
        SpanText(
            text =Strings.current().dragColumnHint ,
            modifier = Modifier
                .fontSize(FontSizes.semiMediumFontSize)
                .color(Theme.TextSecondary.rgb)
                .fontFamily()
        )

    }

}

@Composable
private fun setABCStatisticTableInfo(
    items: List<ABCStatisticItem>?
): Triple<List<TableColumn>, List<Map<String, Any?>>?, Map<String, String>> {

    val columns = ABCStatisticTableHeadersEnum.entries.map { header ->
        TableColumn(
            header = header.title,
            key = header.key,
            isNumeric = header.isNumeric,
            sortFunction = when {
                header.isNumeric -> { row ->
                    (row[header.key]?.toString() ?: "0").replace(",", "")
                        .toDoubleOrNull() ?: 0.0
                }
                header == ABCStatisticTableHeadersEnum.FIRST_SALE ||
                        header == ABCStatisticTableHeadersEnum.LAST_SALE -> { row ->
                    val dateStr = row[header.key]?.toString() ?: ""
                    dateStr
                }
                else -> null
            }
        )
    }

    val tableData = items?.map { item ->
        mapOf(
            "id" to item.productId,
            ABCStatisticTableHeadersEnum.CODE.key to (item.code ?: ""),
            ABCStatisticTableHeadersEnum.NAME.key to (item.name ?: ""),
            ABCStatisticTableHeadersEnum.SALES_GROUP.key to item.salesGroup,
            ABCStatisticTableHeadersEnum.ANZAHL.key to formatToTwoDecimals(item.number),
            ABCStatisticTableHeadersEnum.AMOUNT.key to formatToTwoDecimals(item.total),
            ABCStatisticTableHeadersEnum.WEIGHT.key to formatToTwoDecimals(item.weight),
            ABCStatisticTableHeadersEnum.FIRST_SALE.key to if (item.firstSale != null) {
                "${extractDate(item.firstSale)}, ${extractTime(item.firstSale)}"
            } else "",
            ABCStatisticTableHeadersEnum.LAST_SALE.key to if (item.lastSale != null) {
                "${extractDate(item.lastSale)}, ${extractTime(item.lastSale)}"
            } else ""
        )
    }

    val totalNumber = items?.sumOf { it.number ?: 0.0 } ?: 0.0
    val totalAmount = items?.sumOf { it.total ?: 0.0 } ?: 0.0
    val totalItems = items?.size ?: 0

    val footerData = mapOf(
        ABCStatisticTableHeadersEnum.CODE.key to "${Strings.current().items}: $totalItems",
        ABCStatisticTableHeadersEnum.NAME.key to "",
        ABCStatisticTableHeadersEnum.SALES_GROUP.key to "",
        ABCStatisticTableHeadersEnum.ANZAHL.key to formatToTwoDecimals(totalNumber, true),
        ABCStatisticTableHeadersEnum.AMOUNT.key to formatToTwoDecimals(totalAmount, true),
        ABCStatisticTableHeadersEnum.WEIGHT.key to "",
        ABCStatisticTableHeadersEnum.FIRST_SALE.key to "",
        ABCStatisticTableHeadersEnum.LAST_SALE.key to ""
    )

    return Triple(columns, tableData, footerData)
}